// Sports Betting Configuration
// This file controls the sports betting popup functionality

export const SPORTS_BETTING_CONFIG = {
  // Set to true to enable the popup, false to disable it
  POPUP_ENABLED: false,
  
  // Popup message configuration
  POPUP_MESSAGE: {
    title: "¡Atención importante!",
    content: [
      "Estamos experimentando un problema técnico temporal que afecta las apuestas deportivas.",
      "Por el momento, no podemos ofrecer los mercados deportivos.",
      "Lamentamos la interrupción y estamos trabajando intensamente para resolver esta situación lo antes posible.",
      "Agradecemos su paciencia y comprensión mientras lo solucionamos, les mantendremos informados en nuestras redes sociales."
    ],
    signature: "Gracias por su fidelidad,\nEl equipo de Triunfador.net",
    buttonText: "Entendido"
  }
};

// Helper function to check if popup is enabled
export const isSportsBettingPopupEnabled = () => SPORTS_BETTING_CONFIG.POPUP_ENABLED;
